var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('WindowResize'),_c('router-view'),_c('footer',{staticClass:"fixed-bottom-container"},[_c('footer-container')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }